import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../assets/logo.png';
import _imports_1 from './../assets/icons/google-play.png';
import _imports_2 from './../assets/icons/apple-button.png';
import _imports_3 from './../assets/icons/webgl-button.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-0724bf14"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = { class: "texts-wrap" };
var _hoisted_7 = { class: "logo" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "home-title-head font-ang" }, "Miner's Rush", -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "home-title font-ang" }, "Coming Soon", -1); });
var _hoisted_10 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12 col-md-12 col-xs-12\" data-v-0724bf14><div class=\"panel\" data-v-0724bf14><div class=\"panel-top\" data-v-0724bf14></div><div class=\"panel-middle\" data-v-0724bf14><div class=\"panel-content\" data-v-0724bf14><div class=\"col-np-12\" data-v-0724bf14><p data-v-0724bf14>We are mining hard, when finished the game will be available at the following planforms:</p><img class=\"store-icon\" src=\"" + _imports_1 + "\" data-v-0724bf14><img class=\"store-icon\" src=\"" + _imports_2 + "\" data-v-0724bf14><img class=\"store-icon\" src=\"" + _imports_3 + "\" data-v-0724bf14></div></div></div><div class=\"panel-bottom\" data-v-0724bf14></div></div></div>", 1);
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return ($data.store.commit('goTo', '/')); })
                                })
                            ]),
                            _hoisted_8,
                            _hoisted_9
                        ]),
                        _hoisted_10
                    ])
                ]),
                _hoisted_11
            ])
        ])
    ]));
}
